import { translate } from "../../providers";
import { dangerousSetInnerHTML } from "../../utils";

export default function I18nTranslate({ autoTranslate = "yes", className = "", param, translationKey }) {
	return dangerousSetInnerHTML({ autoTranslate, className, text: translate(translationKey, param) });
}
